import { Bedtime, WbSunny } from "@mui/icons-material";
import { Avatar, Box, Divider, Menu, MenuItem, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import BriaButton from "../../../components/common/BriaButton/BriaButton";
import RouterConstants from "../../../constants/RouterConstants.ts";
import { USER_DEFAULT_AVATAR } from "../../../constants/UserConstants.ts";
import { ThemeMode } from "../../../constants/themes.ts";
import { useTheme } from "../../../context/ThemeContext.tsx";
import useSecureNavigate from "../../../hooks/useSecureNavigate.tsx";
import { useAppStore } from "../../../hooks/useStores";
import iframeStore from "../../../pages/IframeNew/iframe-store.tsx";
import { isFiboApp } from "../../../utils";
import styles from "./UserDropdown.module.scss";

interface IUserDropdown {
	openInNewTab?: boolean;
}
const UserDropdown = ({ openInNewTab }: IUserDropdown) => {
	const { authStore, uiStore } = useAppStore();
	const { mode, changeTheme } = useTheme();
	const { t } = useTranslation("translation", { keyPrefix: "userDropdown" });
	const navigate = useSecureNavigate();
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleChangeTheme = () => {
		changeTheme(
			mode === ThemeMode.Light ? (isFiboApp() ? ("labs" as ThemeMode) : ThemeMode.Dark) : ThemeMode.Light,
		);
	};

	return iframeStore.isIframe() ? (
		<></>
	) : (
		<>
			{authStore.user && (
				<Box className={styles.userIconConainter}>
					<BriaButton
						onClick={(event) => {
							handleClick(event);
						}}
						aria-label={t("accountOfCurrentUser")}
						className={styles.avatarButton}
						disableRipple
					>
						<Avatar
							src={authStore.user?.profilePicture ?? USER_DEFAULT_AVATAR}
							className={styles.avatarStyle}
						/>
					</BriaButton>
				</Box>
			)}
			<Menu
				anchorEl={anchorEl}
				open={Boolean(anchorEl)}
				onClose={handleClose}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "center",
				}}
				className={styles.menuWrapper}
				// PaperProps={{
				// 	style: {
				// 		width: 150,
				// 	},
				// }}
			>
				<MenuItem
					onClick={() => {
						handleClose();
						openInNewTab
							? window.open(RouterConstants.USER_PROFILE.fullPath, "_blank")
							: navigate(RouterConstants.USER_PROFILE.fullPath);
					}}
					className={styles.menuItem}
				>
					<Typography variant="inherit">{t("profile")}</Typography>
				</MenuItem>
				{authStore.isLoggedIn && authStore.user?.isSuperAdmin() && (
					<MenuItem
						onClick={() => uiStore.showDialog("SubscriptionLinkGeneratorPopup")}
						className={styles.menuItem}
					>
						<Typography variant="inherit">{t("generateSubscriptionLink")}</Typography>
					</MenuItem>
				)}
				{authStore.isLoggedIn && authStore.user?.isSuperAdmin() && (
					<MenuItem onClick={() => uiStore.showDialog("OrgInfoPopup")} className={styles.menuItem}>
						<Typography variant="inherit">{t("viewOrgInfo")}</Typography>
					</MenuItem>
				)}
				<MenuItem
					onClick={() => {
						handleChangeTheme();
						handleClose();
					}}
					className={styles.menuItem}
				>
					<Typography variant="inherit" className={styles.themeModeLabel}>
						{mode === ThemeMode.Light ? <Bedtime /> : <WbSunny />}
						{t(mode === ThemeMode.Light ? "darkMode" : "lightMode")}
					</Typography>{" "}
				</MenuItem>
				<Divider className={styles.divider} />
				<MenuItem
					className={styles.menuItem}
					onClick={() => {
						authStore.logout();
					}}
				>
					<Typography variant="inherit">{t("logout")}</Typography>
				</MenuItem>
			</Menu>
		</>
	);
};

export default observer(UserDropdown);
